// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 441) return "static/chunks/441-94512cfaea2dd513.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"22":"e5c4b7107e3cc59e","54":"c83baa724f68656f","346":"b4cccbe858864c2c","524":"13dfa29957741933","668":"72b44a9cb54663c3"}[chunkId] + ".js";
};